import { Component, OnDestroy, OnInit } from '@angular/core';
import { Filter, SessionCookieService } from '@docpath/linces-angular-components/common';
import { User } from '@docpath/linces-angular-components/common/services/login/models/user.model';
import { DpButtonStateIcon, DpFieldButton, DpSectionForm, Table } from '@docpath/webcomponents';
import { Subscription } from 'rxjs';

import { Constants } from '../../../constants/constants';
import { IndexServicesTableService } from './components/table/index-services-table.service';
import { IndexService } from './models/index-service';
import { AimConfig, ServicesConfig } from './models/services-config';
import { AimFormService } from './services/aim-form.service';
import { AimHttpService } from './services/aim-http.service';
import { IndexServicesService } from './services/index-services.service';


@Component({
  selector: 'app-services',
  templateUrl: './services.component.html'
})
export class ServicesComponent implements OnInit, OnDestroy {

  sectionForm: DpSectionForm;
  filters: Filter[] = [];
  selectedIndexServices: IndexService[] = [];

  isAdminUser = false;

  private table?: Table;
  private indexServicesChangedSubscription?: Subscription;

  constructor(
    private readonly sessionCookieService: SessionCookieService,
    private readonly servicesHttpService: AimHttpService,
    private readonly aimService: AimFormService,
    private readonly indexServicesService: IndexServicesService,
    private readonly indexServicesTableService: IndexServicesTableService) {
    this.sectionForm = this.aimService.getSectionForm(fieldButton => this.testConnection(fieldButton));
    const { role } = this.sessionCookieService.getSessionCookie()?.user as User;
    this.isAdminUser = role === Constants.ROLE_ADMIN;
  }

  ngOnInit(): void {
    this.servicesHttpService.getConfig().subscribe(config => {
      const aimConfig = new AimConfig(config.url, config.appToken);
      this.sectionForm.setValue(new ServicesConfig(aimConfig));
    });
    if (!this.indexServicesChangedSubscription) {
      this.indexServicesChangedSubscription = this.indexServicesService.indexServicesChanged.subscribe(() => this.refreshIndexServices());
    }
  }

  ngOnDestroy(): void {
    if (this.indexServicesChangedSubscription) {
      this.indexServicesChangedSubscription.unsubscribe();
    }
  }

  submitForm(value: unknown) {
    const config = value as ServicesConfig;

    this.servicesHttpService.updateConfig(config).subscribe(() => {
      this.sectionForm.setValue(config);
    });
  }

  private testConnection(testButton: DpFieldButton) {
    const url = this.sectionForm.formGroup?.get('aim.url')?.value,
      appToken = this.sectionForm.formGroup?.get('aim.appToken')?.value;

    testButton.state = DpButtonStateIcon.Loading;

    this.servicesHttpService.testConnection(url, appToken).subscribe(response => {
      testButton.state = response.result ? DpButtonStateIcon.Success : DpButtonStateIcon.Error;
    });
  }

  getTable(): Table | undefined {
    return this.table;
  }

  onTableLoaded(table: Table): void {
    this.table = table;
  }

  onFilterChange(filters: Filter[]): void {
    this.filters = filters;
  }

  onCheckChange(): void {
    if (this.table) {
      this.selectedIndexServices = this.indexServicesTableService.getSelectedIndexServices(this.table);
    }
  }

  getSelectedIndexServiceCount(): number {
    if (this.table) {
      const indexServices = this.indexServicesTableService.getSelectedIndexServices(this.table);
      return indexServices.length;
    }
    return 0;
  }

  getSelectedIndexService(): IndexService | undefined {
    if (this.table) {
      const indexServices = this.indexServicesTableService.getSelectedIndexServices(this.table);
      return indexServices.length === 1 ? indexServices[0] : undefined;
    }

    return undefined;
  }

  private refreshIndexServices(): void {
    this.indexServicesTableService.loadIndexServices(this.filters, 1);
  }
}